import type { Lang } from './strings';

const locale = (lang: Lang) => (lang === 'sq' ? 'sq-AL' : 'en-GB');

export function fmtDate(iso: string | null | undefined, lang: Lang) {
  if (!iso) return '';
  return new Intl.DateTimeFormat(locale(lang), { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(iso));
}
export function fmtDayShort(iso: string, lang: Lang) {
  return new Intl.DateTimeFormat(locale(lang), { weekday: 'short', day: 'numeric', month: 'short' }).format(new Date(iso));
}
export function fmtTime(iso: string | null | undefined, lang: Lang) {
  if (!iso) return '';
  return new Intl.DateTimeFormat(locale(lang), { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(iso));
}
export function fmtDateTime(iso: string | null | undefined, lang: Lang) {
  if (!iso) return '';
  return `${fmtDayShort(iso, lang)}, ${fmtTime(iso, lang)}`;
}
export function fmtHours(h: number | null | undefined) {
  if (h === null || h === undefined) return '–';
  const totalMin = Math.round(h * 60);
  return `${Math.floor(totalMin / 60)}:${String(totalMin % 60).padStart(2, '0')}`;
}
export function fmtDistance(m: number | null | undefined) {
  if (m === null || m === undefined) return '';
  return m >= 1000 ? `${(m / 1000).toFixed(1)} km` : `${Math.round(m)} m`;
}

/** Value for <input type="datetime-local"> from an ISO string, in the browser's time zone. */
export function toLocalInput(iso: string | null | undefined) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fromLocalInput(v: string) {
  return v ? new Date(v).toISOString() : '';
}
/** YYYY-MM-DD for <input type="date">. */
export function toDateInput(d: Date) {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
export function startOfWeek(d = new Date()) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); // Monday
  return x;
}
export function addDays(d: Date, n: number) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}
export const mapsLink = (lat: number, lng: number) => `https://www.google.com/maps?q=${lat},${lng}`;
